/* eslint-disable no-lone-blocks */
import React, { Component } from 'react';
import { Select, Spin, Empty, DatePicker, InputNumber, Input, Modal, Tooltip } from 'antd';
import { InfoCircleOutlined,PlusOutlined } from '@ant-design/icons';
import postService from './../../../services/httpService';
import networkList from './../../../constants/networkList';
import Select2 from './../../FormComponent/select2';
import InputNumberlayer from './../../FormComponent/InputNumberlayer';
import Datepicker from './../../FormComponent/Date';
import Checkboxlayer from './../../FormComponent/CheckboxLayer'
const { Option } = Select;

class Tableantd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'table_head': [], 'table_body': [], 'add_more': false, 'add_more_title': null
        }

    }

    componentDidMount() {
        console.log('mani',this.props.table_data)
        let { table_head, table_body, add_more, add_more_title } = this.props.table_data;
        this.setState({ 'table_head': table_head, 'table_body': table_body, 'add_more': add_more, 'add_more_title': add_more_title })
    }

    

    updateTablebody() {
        let { table_from } = this.props;
       
    }

    handleChange(data) {
        
        let { name, id, value,selected_option,table } = data;
        let { slug } = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        const cd = params.get('cd');
        this.setState({ error_message: '', error_view: false });
        this.props.change(data);  
       
    }

    addButton() {
        let { table_from } = this.props;
        try {
            let add_more_feilds = this.props.table_data.add_more_feilds;
            let { table_body } = this.state;

            let last_element = table_body[table_body.length - 1];
            let last_id = (last_element && last_element['id']) ? last_element['id'] : 0;
            let add_more = JSON.parse(JSON.stringify(add_more_feilds));

            add_more.map((feild, key) => {
                add_more[key]['id'] = last_id + 1;
                add_more[key]['value'] = null;
                add_more[key]['text'] = null;
            })

            let obj = [{
                'id': last_id + 1,
                'key_word': 'add_more',
                text: "Highend", type: "text", input_feild: [],
                'feilds': add_more
            }]
                this.props.change(obj);
                this.setState((state) => ({ 'table_body': state.table_body.concat(obj) }), () => {
                    let { table_body } = this.state;
                    console.log(table_body)
                })
            
        } catch (error) {
            console.log(error);
        }
    }

    deleteRow(row_id) {
        let table_body = this.state.table_body;
        let { table_from, form_table } = this.props;

        // if (row_id) {
        try {
            if (table_body.length > 1) {
                let removed_obj = table_body.splice(row_id, 1);
                    this.props.deleteLineItem(removed_obj);
            } else {
                // if (row_id === 0 && form_table !== 'additional_packages' && form_table !== 'additional_procedures' ) {
                //         table_body.map((body, key) => {
    
                //             if (key === row_id && body['feilds']) {
                //                 body['feilds'].map((feild, feild_key) => {
                //                     if (feild.name === 'drugs_name') {
                //                         table_body[key]['feilds'][feild_key]['value'] = null;
                //                         table_body[key]['feilds'][feild_key]['text'] = null;
                //                     }
                //                     if (feild.name === 'investigation_name') {
                //                         table_body[key]['feilds'][feild_key]['value'] = null;
                //                         table_body[key]['feilds'][feild_key]['text'] = null;
                //                     }
                //                     if (feild.name === 'procedures_name') {
                //                         table_body[key]['feilds'][feild_key]['value'] = null;
                //                         table_body[key]['feilds'][feild_key]['text'] = null;
                //                     }
                //                     if (feild.name === 'qty') {
                //                         table_body[key]['feilds'][feild_key]['value'] = null
                //                     }
                //                 })
                //             }
                //         })
                //     }
                if (row_id === 0) {
                    let removed_obj = table_body.splice(row_id, 1);
                    this.props.deleteLineItem(removed_obj);
                }
            }


        } catch (error) {
            console.log(error);
        }
        // }
    }
    render() {
        let { table_head, table_body, add_more, add_more_title } = this.state;
        return (<table className="table table-hover table-bordered">
            <thead>
                <tr>
                    {table_head.map((head, hKey) => {
                        return (<td style={{ width: head.width }} key={hKey}>{head.text}</td>)
                    })}

                </tr>
            </thead>

            <tbody>

                {table_body.length > 0 && table_body.map((feild, key) => {
                    return (
                        <tr key={key}>
                            <td>{key + 1}</td>

                            {feild.feilds.map((input, inkey) => {
                                if (input.visible && input.element === 'input') {
                                    return (
                                        <td key={inkey}>
                                            <div className="row mx-0">
                                                    <div className="col px-0">
                                            <InputNumberlayer {...this.props} {...this.state} selectdata={input} onInputChanges={this.handleChange.bind(this)} />
                                            {input.errors.map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger" style={{fontSize: '10px'}}>{error.message}</small>
                                                            );
                                                        })}
                                                        </div>
                                                        </div>
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'select') {
                                    return (
                                        <React.Fragment key={key}>
                                            <td key={inkey}>
                                                <div className="row mx-0">
                                                    <div className="col px-0">
                                                        <Select2
                                                            selectdata={input}
                                                            changedObj={this.state.changedObj}
                                                            {...this.props}
                                                            {...this.state}
                                                            Queuedata={this.state.formData}
                                                            onselectChanges={this.handleChange.bind(this)} />
                                                        {input.errors.map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger" style={{fontSize: '10px',marginBottom:'6px'}}>{error.message}</small>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </td>
                                        </React.Fragment>
                                    )
                                   
                                }
                                if (input.visible && input.element === 'datepicker') {
                                    return (
                                        <td key={inkey}>
                                          
                                            <Datepicker selectdata={input}
                                                changedObj={this.state.changedObj}
                                                {...this.props}
                                                {...this.state}
                                                Queuedata={this.state.formData}
                                                onselectChanges={this.handleChange.bind(this)} />
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'checkbox') {
                                    return (
                                        <td key={inkey}>
                                            
                                            <Checkboxlayer selectdata={input}
                                                changedObj={this.state.changedObj}
                                                {...this.props}
                                                {...this.state}
                                                Queuedata={this.state.formData}
                                                onselectChanges={this.handleChange.bind(this)} />
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'action') {
                                    return (
                                        <td key={inkey}>
                                            <Tooltip placement="top" title='Remove'>
                                                <img src="/assets/images/icons/delete.png" alt="Remove" className="mr-2" onClick={this.deleteRow.bind(this, key)} />
                                            </Tooltip>
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'text') {
                                    return (
                                        <td key={inkey} colSpan={input.colSpan}>
                                            {input.tooltip ? <Tooltip   placement="topRight" color={'red'} title={input.tooltip}>{input.title}
                                                <InfoCircleOutlined style={{ "font-size": "16px", "margin-left": "20px" }} />
                                            </Tooltip> : input.title}
                                        </td>
                                    )
                                }
                            })}

                        </tr>)


                })}

                {(add_more) && <tr>
                    <td colSpan={table_head.length} className="text-right">
                        <button className="btn  btn-next text-capitalize" onClick={() => this.addButton(this)}><PlusOutlined  className="antadd_bt"/> {add_more_title}</button>
                        
                    </td>
                </tr>
                }
            </tbody>
        </table>)
    }
}

export default Tableantd;
